<template>
<div>
  <div class="detail-type">{{ msgType == 1 ? message : todo }}</div>
  <div class="detail-wrap">
    <div class="detail-title">
      {{ itemData.title }}
    </div>
    <mavon-editor
      v-model="itemData.content" 
      defaultOpen="preview" 
      :subfield="false" 
      :editable="false" 
      :toolbarsFlag="false"
      class="mavon-sty"
    />
    <!-- <div v-html="compiledMarkdown" class="markdown-body"></div> -->
  </div>

  <div class="dialog-btn-wrap" v-if="msgType == 2">
    <lls-button
      v-if="isUnRead(itemData, msgType)"
      type="primary" 
      class="submit-btn" 
      style="height: 32px; padding: 10px 30px;"
      @click="handleMarkDone">
      {{ markAsDone }}
    </lls-button>
  </div>
</div>
</template>
<script>
import { isUnRead } from '../func.js'

export default {
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
    msgType: { // 1-Message 2-todo
      default: 0,
      type: Number
    },
    countObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentPage1: 1,
      multipleSelection: [],
      message: '',
      todo: '',
      markAsDone: ''
    }
  },
  components: {
  },
  mounted() {
    this.message = vm.$t('message.message')
    this.todo = vm.$t('message.todo')
    this.markAsDone = vm.$t('message.markAsDone')
  },
  methods: {
    isUnRead() {
      const a = isUnRead(...arguments, this.msgType)
      return a
    },
    // 处理 to do
    async handleMarkDone() {
      this.$emit('handleMarkDone', this.itemData)
    },
  }
}
</script>
<style scoped lang="scss">
.detail-wrap {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 510px;
  margin: 50px auto;
  color: #7A7A7A;
}
.detail-type {
  font-size: 18px;
  color: #4E78B1;
  text-align: center;
  font-weight: 700;
}
.detail-title {
  color: #262626;
  font-size: 16px;
  font-weight: 600;
}
.dialog-btn-wrap {
  display: flex;
  justify-content: center;
  
}
.mavon-sty {
  box-shadow: none !important;
  max-height: calc(70vh - 120px);
  word-break: break-word;
  ::v-deep {
    .v-show-content {
      background-color: #fff !important;
      padding: 10px 0 !important;
    }
  }
}
</style>